import React, { memo } from 'react';
import { formatLastMessageAt, formatLastMessageAtFull } from '../utils/dates';

// FASE 2: Componentes optimizados con React.memo
const ChatItem = memo(({ chat, isSelected, onChatSelect, botTimezone }) => {
  console.log(`🔄 RENDERIZANDO ChatItem: ${chat.name} (${chat.platform})`);
  
  // ✅ CRÍTICO: Key única incluyendo botId para evitar mezclar chats de diferentes bots
  const uniqueKey = chat.botId ? `${chat.chatId}_bot_${chat.botId}` : chat.chatId;

  // El backend expone `lastMessageTime` (UnifiedChatDTO) y la entidad usa `lastMessageAt`.
  // Aceptamos ambos por compatibilidad con cualquier endpoint.
  const rawLastMessageAt = chat.lastMessageTime || chat.lastMessageAt || chat.updatedAt;
  const lastMessageLabel = formatLastMessageAt(rawLastMessageAt, botTimezone);
  const lastMessageTitle = formatLastMessageAtFull(rawLastMessageAt, botTimezone);

  return (
    <div
      key={uniqueKey}
      className={`chat-item ${isSelected ? 'active' : ''}`}
      onClick={() => onChatSelect(chat)}
    >
      <div className={`chat-avatar platform-badge ${chat.platform}`}>
        <img 
          src={chat.platform === 'telegram' ? '/tg.png' : chat.platform === 'instagram' ? '/ig.png' : '/wa.svg'} 
          alt={chat.platform}
          className="platform-icon"
        />
      </div>
      <div className="chat-info">
        <div className="chat-name">
          {chat.name}
        </div>
        <div className="chat-last-message">{chat.lastMessage}</div>
      </div>
      {chat.unread > 0 && (
        <div className="unread-badge">{chat.unread}</div>
      )}
      {lastMessageLabel && (
        <div className="chat-last-message-time" title={lastMessageTitle}>
          {lastMessageLabel}
        </div>
      )}
    </div>
  );
});

export default ChatItem;
